import React, { useState } from "react";
import { Mail, MessageSquare, Users } from "lucide-react";
import { contactMessagesService } from "@/lib/supabase";

export interface ContactOptionType {
  icon: React.ReactNode;
  title: string;
  description: string;
  email: string;
  delay: number;
}

export const useContact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const contactOptions: ContactOptionType[] = [
    {
      icon: <MessageSquare className="h-6 w-6" />,
      title: "General Inquiries",
      description:
        "For any questions about our content, tips, or website features.",
      email: "contact@glowher.life",
      delay: 0.1,
    },
    {
      icon: <Users className="h-6 w-6" />,
      title: "Partnerships",
      description:
        "For collaboration opportunities, sponsorships, and business proposals.",
      email: "partners@glowher.life",
      delay: 0.2,
    },
    {
      icon: <Mail className="h-6 w-6" />,
      title: "Feedback",
      description:
        "We value your thoughts on how we can improve and better serve you.",
      email: "feedback@glowher.life",
      delay: 0.3,
    },
  ];

  const sendMessage = async (
    name: string,
    email: string,
    subject: string,
    message: string
  ) => {
    setIsSubmitting(true);
    setError(null);

    try {
      const result = await contactMessagesService.send(
        name,
        email,
        subject,
        message
      );

      if (result.success) {
        setIsSubmitted(true);
        return true;
      } else {
        setError(
          result.error ||
            "Có lỗi xảy ra khi gửi tin nhắn. Vui lòng thử lại sau."
        );
        return false;
      }
    } catch (err) {
      console.error("Error sending message:", err);
      setError("Có lỗi xảy ra khi gửi tin nhắn. Vui lòng thử lại sau.");
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    contactOptions,
    sendMessage,
    isSubmitting,
    isSubmitted,
    error,
  };
};
